import React from 'react'
import { css } from 'aphrodite'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'

import Sitemap from '../partials/Sitemap'
import PartnerBox from './partials/PartnerBox'

import partnerList from './partners.json'

import style from './style'

const sitemapHeader = [
  { url: '/', title: 'Home' },
  { url: '/partners', title: 'Partners' }
]

export class PartnersScreen extends React.Component {
  render () {
    return [
      <Sitemap key={0} sitemap={sitemapHeader} />,
      <section key={1} className={css(style.main.section)}>
        <Container>
          <Row>
            <Col xs='12' md='9'>
              {partnerList.map((item, index, arr) => {
                if (index < arr.length - 1) {
                  return [
                    <PartnerBox key={`gb_${index}`} {...item} />,
                    <hr
                      key={`hr_${index}`}
                      className={css(style.main.spacer)}
                    />
                  ]
                }

                return <PartnerBox key={`gb_${index}`} {...item} />
              })}
            </Col>
            <Col xs='12' md='3'>
              <h4 className={css(style.sidebar.h4)}>
                <strong className={css(style.sidebar.h4Bold)}>Partner</strong>{' '}
                Up
              </h4>
              <p className={css(style.sidebar.p)}>
                <em>
                  <Link to='/contact' className={css(style.sidebar.link)}>
                    Contact Us
                  </Link>
                  &nbsp;if you'd like to discuss partnership opportunities.
                </em>
              </p>
              <hr className={css(style.main.spacer)} />
            </Col>
          </Row>
        </Container>
      </section>
    ]
  }
}

export default PartnersScreen



// WEBPACK FOOTER //
// ./src/components/Partnets/index.js